import * as React from 'react';

export interface NeighborhoodProps {
  neighborhood?: string;
}

export const Neighborhood: React.FunctionComponent<NeighborhoodProps> = ({ neighborhood }) => {
  if (!neighborhood) {
    return null;
  }

  return (
    <div
      className="listing__neighborhood uitk-type-regular pwa-theme--grey-700 truncate all-b-padding-two uitk-type-300"
      data-stid="content-hotel-neighborhood"
    >
      {neighborhood}
    </div>
  );
};
Neighborhood.displayName = 'Neighborhood';
